module.exports = {"150123100":"城关镇","150123101":"盛乐镇","150123102":"新店子镇","150123203":"舍必崖乡","150123205":"大红城乡","150123206":"羊群沟乡","150123207":"黑老夭乡","150123208":"巧什营乡","150123400":"盛乐经济工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150123.json
// module id = 397
// module chunks = 0